import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { APP_VERSION } from 'version';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { deleteEmptyArrayValues } from 'helpers/deleteEmptyArrayValues';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';
import { routes } from 'constants/routes';
import { Account } from 'common/Sidebar/Account';
import logo from 'assets/icons/logo.svg';
import styles from 'common/Sidebar/Sidebar.scss';

export const Sidebar = () => {
  const selectedLocation = SessionStorageUtils.getData(SessionStorageKeys.LOCATION);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    const basePath = selectedLocation?.admin ? routes[0].path : selectedLocation?.transliteration;

    navigate(basePath || '/');
  };

  const isLinkActive = (path) => {
    const routePath = path.replace(/^\//, '');
    const pathParts = deleteEmptyArrayValues(pathname.split('/'));
    const index = selectedLocation?.admin ? 0 : 1;

    return pathParts[index] === routePath;
  };

  const isRouteAvailableForLocation = (routeKey) => {
    const isAdminLocation = selectedLocation?.admin;
    const availableRoutes = selectedLocation?.availableRoutes || [];

    if (isAdminLocation) return true;
    if (!selectedLocation) return false;

    return availableRoutes.length ? availableRoutes.includes(routeKey) : true;
  };

  const buildPath = (path) => {
    const basePath = selectedLocation?.admin ? path : `/${selectedLocation.transliteration}${path}`;

    return basePath.replace('//', '/');
  };

  const filteredRoutes = routes.filter(
    ({ hideInMenu, title, key }) => !hideInMenu && title && isRouteAvailableForLocation(key)
  );

  return (
    <aside className={styles.sidebar}>
      <button className={styles.logo} onClick={handleHomeNavigation}>
        <img src={logo} alt='M.U.ST Dance&Win logo' />
      </button>
      {isAuthenticated && selectedLocation && (
        <>
          <nav>
            <ul className={styles.navigation}>
              {filteredRoutes
                .filter(({ key, hideInMenu }) => !hideInMenu && isRouteAvailableForLocation(key))
                .map(
                  ({ key, title, path, icon }) =>
                    title && (
                      <li className={styles.navigationItem} key={key}>
                        <Link to={buildPath(path)} className={cn(styles.link, { [styles.active]: isLinkActive(path) })}>
                          <FontAwesomeIcon icon={icon} className={styles.icon} />
                          <div className={styles.tooltip}>{title}</div>
                        </Link>
                      </li>
                    )
                )}
            </ul>
          </nav>
          <Account />
          <span className={styles.version}>{APP_VERSION}</span>
        </>
      )}
    </aside>
  );
};
